import { motion } from "framer-motion";

const items = [
  {
    n: "01",
    title: "Legacy → SaaS",
    body: "Transformed legacy platforms into scalable SaaS products with modern operating models — reducing run-rate cost and unlocking expansion revenue.",
  },
  {
    n: "02",
    title: "Multi-million Growth",
    body: "Defined product strategies that unlocked multi-million revenue growth across the UK, EU, US, Middle East and APAC.",
  },
  {
    n: "03",
    title: "PMF & Funding-Readiness",
    body: "Guided startups to product–market fit and investor readiness through focused product bets and a credible board narrative.",
  },
  {
    n: "04",
    title: "Valuation & Exit",
    body: "Aligned product strategy with valuation outcomes — and built the product story that holds up under diligence.",
  },
];

export const Impact = () => {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative bg-[#050505] py-20 sm:py-28 md:py-40 border-t border-[#141414]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A880]" />
              <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
                Selected Impact / 05
              </span>
            </div>
            <h2
              data-testid="impact-heading"
              className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] lg:leading-[1.05] tracking-tight text-[#F5F5F0]"
            >
              Outcomes that compound — across products,{" "}
              <em className="italic text-[#C5A880]">teams</em> and valuations.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#1a1a1a]">
          {items.map((it, i) => (
            <motion.div
              key={it.n}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              data-testid={`impact-item-${it.n}`}
              className="p-6 sm:p-8 md:p-10 border-r border-b border-[#1a1a1a] hover:bg-[#0b0b0b] transition-colors min-h-[220px] sm:min-h-[260px] flex flex-col"
            >
              <div className="text-[11px] tracking-[0.3em] text-[#C5A880] mb-6 sm:mb-8">
                — {it.n}
              </div>
              <h3 className="font-serif-display text-xl sm:text-2xl md:text-3xl font-light text-[#F5F5F0] mb-3 sm:mb-4 leading-tight">
                {it.title}
              </h3>
              <p className="text-[#A3A39A] text-[14px] sm:text-sm md:text-base leading-relaxed mt-auto">
                {it.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
